import { Navigate } from "react-router";

import ProtectedRoute from "@accredo/fe-shared/routes/ProtectedRoute.jsx";
import RouteErrorBoundary from "@accredo/fe-shared/routes/RouteErrorBoundary.jsx";
import LoginPage from "@accredo/fe-shared/pages/LoginPage.jsx";
import { PORTAL } from "@accredo/fe-shared/theme/portals.js";
import CustomerPortalLayout from "./CustomerPortalLayout.jsx";
import PortalPlaceholderPage from "./pages/PortalPlaceholderPage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import ContractDetailPage from "./pages/ContractDetailPage.jsx";
import ContractListPage from "./pages/ContractListPage.jsx";
import DocumentListPage from "./pages/DocumentListPage.jsx";
import ObjectListPage from "./pages/ObjectListPage.jsx";

/**
 * The routes of the Kundenportal, kept apart from the Schadenportal ones so
 * that a Schadenportal address cannot be reached on this hostname. Anything
 * unknown goes to the dashboard rather than nowhere.
 */
export const customerPortalRoutes = [
  {
    element: <CustomerPortalLayout />,
    children: [
      {
        path: "/",
        element: <DashboardPage />,
      },
      {
        path: "/vertraege",
        element: <ContractListPage />,
      },
      {
        path: "/vertraege/:id",
        element: <ContractDetailPage />,
      },
      {
        path: "/objekte",
        element: <ObjectListPage />,
      },
      {
        path: "/dokumente",
        element: <DocumentListPage />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

/**
 * The Kundenportal's full route tree: the login stands on its own, and
 * everything else sits behind `ProtectedRoute`, which also refuses a
 * signed-in user without Kundenportal access.
 */
export const appRoutes = [
  {
    path: "/login",
    element: <LoginPage appTitle="Kundenportal" homePath="/" />,
  },
  {
    element: <ProtectedRoute portal={PORTAL.KUNDENPORTAL} />,
    errorElement: <RouteErrorBoundary />,
    children: customerPortalRoutes,
  },
];
